import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap';
import { DemoService } from 'src/app/demo.service';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { MysqlService } from 'src/app/services/mysql.service';
import { SystemAutomation } from 'src/app/shared/models/systemAutomation.model';
import {Location} from '@angular/common';
import { SystemNotice } from 'src/app/shared/models/systemNotice.model';

@Component({
  selector: 'app-system-notice-create',
  templateUrl: './system-notice-create.component.html',
  styleUrls: ['./system-notice-create.component.scss']
})
export class SystemNoticeCreateComponent implements OnInit {

  model: SystemNotice;
  get_latest_notice_id: Object;
  brands: any;
  users: any;
  user_levels: any;
  cValue: any;


  @Input('value')
      set value(value: any) {
          this.cValue = value;
      }
  
 @Input('brandForm') brandForm: any;




  constructor(
        private _mysqlService: MysqlService,
        private route: ActivatedRoute,
          private router: Router,
          private http: HttpClient,
          private _demoService: DemoService,
          vcr: ViewContainerRef,
          private modalService: BsModalService,
          private _location: Location,
          public gfunc: GlobalFunctionsService,
          public toastr: HotToastService,
  ) { }

  ngOnInit(): void {
      this.model = new SystemNotice();


      this.getBrands();
      this.getUsers();
      this.getUserLevels();

      this.model = {
        title: '',
        message: '',
        description: '',
        start_datetime: '',
        end_datetime: '',
        show_on_login: 0,
        route_paths: '',
        active: 1,
        show_as_modal: 0,
        show_to_user_levels_below: null ,
        show_to_user_level_only: null,
        show_to_brands: null,
        show_to_users: null,
        created_by: this.gfunc.sessionUserId || 0,
        show_to_tfa_user: '',
        show_on_logout: '',
        colour: '#000',
        icon: 'fa fa-terminal',
      };

      this.model.show_on_login = this.model.show_on_login == 1;
      this.model.show_as_modal = this.model.show_as_modal == 1;
      this.model.active = this.model.active == 1;
      this.model.show_to_tfa_user = this.model.show_to_tfa_user == 1;
      this.model.show_on_logout = this.model.show_on_logout == 1;


  }





  createSystemNotice(model) {
    // cannot be null in sql violation error
    this.model.created_by = this.gfunc.sessionUserId || 1; // if needed
    this.model.active = 1;
    this.model.route_paths = this.model.route_paths || ''; // comma separated
    // Convert checkboxes to numbers before sending:  
    this.model.show_on_login = this.model.show_on_login ? 1 : 0;
    this.model.show_as_modal = this.model.show_as_modal ? 1 : 0;
    this.model.active = this.model.active ? 1 : 0;
          
    this.model.show_to_tfa_user = this.model.show_to_tfa_user ? 1 : 0;
    this.model.show_on_logout = this.model.show_on_logout ? 1 : 0;
    
    this._demoService.createSystemNotice(model).subscribe(
         data => {  this.get_latest_notice_id = data; // this is the retuned json upon creation.
          this.toastr.success('New System Notice Added.');
        this.gfunc.globalSystemNoticesSkipRoute();
          return true;
         },
         error => {
           this.toastr.error('Adding Notice Failed :: Please try again!');
           // console.log(Observable.throw(error));
           // return Observable.throw(error);
         }
    );
    }





    private getBrands() {
      this._demoService.getBrands() 
        .subscribe(
          res => this.brands = res,
          err => console.error(err.status)
        );
    }


    private getUsers() {
      this._demoService.getUsers().subscribe(
        data => { this.users = data;
         let res = data[0];
       },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
    }


    private getUserLevels() {
      this._demoService.getUserLevels().subscribe(
        data => { this.user_levels = data;
         let res = data[0];
       },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
    }



    setColour(value2){
      console.log('SetColour: ' + value2)
      this.brandForm.colour.value = this.brandForm.colourpicker.value
    }
  
  
  

}
